import { css } from '@emotion/core'
import { colors } from '@fs/zion-ui'
import React, { type CSSProperties, type ReactNode } from 'react'

const roundedCardCss = css`
  border-radius: 8px;
  border: 1px solid ${colors.transparent.gray10};
  /** Force children to respect border radius. */
  overflow: hidden;
`

type Props = {
  children: ReactNode
  style?: CSSProperties
}

export default function RoundedCard({ children, style }: Props): JSX.Element {
  return (
    <div css={roundedCardCss} style={style}>
      {children}
    </div>
  )
}
